"use strict";
// NOTE: this file is deprecated
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphaLpBreakdown = alphaLpBreakdown;
exports.cetusLpBreakdown = cetusLpBreakdown;
exports.lastAutocompoundTime = lastAutocompoundTime;
async function alphaLpBreakdown(poolName) {
    const lp = {
        coinA: null,
        coinAInUsd: null,
        coinB: null,
        coinBInUsd: null,
        liquidity: null,
    };
    console.log(poolName);
    return lp;
}
async function cetusLpBreakdown(poolName) {
    const lp = {
        coinA: null,
        coinAInUsd: null,
        coinB: null,
        coinBInUsd: null,
        liquidity: null,
    };
    console.log(poolName);
    return lp;
}
async function lastAutocompoundTime(poolName) {
    console.log(poolName);
    return "1234";
}
//# sourceMappingURL=vaultFunctions.js.map